import { cn } from '@/lib/utils';
import { SPACING, SURFACE } from './tokens';

type Tone = 'default' | 'muted' | 'inverted';
type Width = 'wide' | 'narrow';
type Pad = 'default' | 'tight';

interface SectionProps {
  children: React.ReactNode;
  tone?: Tone;
  width?: Width;
  pad?: Pad;
  id?: string;
  ariaLabelledBy?: string;
  className?: string;
}

const TONE_CLASSES: Record<Tone, string> = {
  default: SURFACE.base,
  muted: SURFACE.muted,
  inverted: SURFACE.inverted,
};

export function Section({
  children,
  tone = 'default',
  width = 'wide',
  pad = 'default',
  id,
  ariaLabelledBy,
  className,
}: SectionProps) {
  return (
    <section
      id={id}
      aria-labelledby={ariaLabelledBy}
      className={cn(
        'relative overflow-hidden',
        TONE_CLASSES[tone],
        pad === 'tight' ? SPACING.sectionTight : SPACING.section,
        className,
      )}
    >
      <div
        className={cn(
          'relative',
          SPACING.container,
          width === 'narrow' && 'max-w-4xl',
        )}
      >
        {children}
      </div>
    </section>
  );
}
